import { render } from "./QDSPage.vue?vue&type=template&id=7df19397"
import script from "./QDSPage.vue?vue&type=script&lang=js"
export * from "./QDSPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__